import { Currency } from '@uniswap/sdk'
import React from 'react'
import styled from 'styled-components'
import CurrencyLogo from '../CurrencyLogo'

const Wrapper = styled.div<{ margin: boolean; sizeraw: number; marginTop: number, imgSeft?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 6).toString() + 'px'};
  margin-top: ${({ marginTop }) => marginTop + 'px'};
  
  img{
    &:last-of-type{
      transform: ${({ sizeraw, imgSeft }) => `translateX(-${imgSeft ? (sizeraw / 4) : 0}px)`} !important;
    }
  }
`

interface DoubleCurrencyLogoProps {
  margin?: boolean
  size?: number
  currency0?: Currency
  currency1?: Currency
  marginTop?: number
  imgSeft?: boolean
}

const HigherLogo = styled(CurrencyLogo)`
  z-index: 2;
`
const CoveredLogo = styled(CurrencyLogo) <{ sizeraw: number }>`
  position: absolute;
  left: ${({ sizeraw }) => '-' + (sizeraw / 2).toString() + 'px'} !important;

`

export default function DoubleCurrencyLogo({
  currency0,
  currency1,
  size = 16,
  margin = false,
  marginTop = 0,
  imgSeft = true
}: DoubleCurrencyLogoProps) {
  return (
    <Wrapper sizeraw={size} margin={margin} marginTop={marginTop}  imgSeft={imgSeft}>
      {currency0 && <HigherLogo currency={currency0} size={size.toString() + 'px'} />}
      {currency1 && <CoveredLogo currency={currency1} size={size.toString() + 'px'} sizeraw={size} />}
    </Wrapper>
  )
}
